import 'leaflet/dist/leaflet.css';
import 'maplibre-gl/dist/maplibre-gl.css';
import 'leaflet-control-geocoder/dist/Control.Geocoder.css';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.min.css';

import L from 'leaflet';
import 'maplibre-gl';
import 'leaflet-control-geocoder';
import '@maplibre/maplibre-gl-leaflet';
import 'leaflet-gesture-handling';

Window.L = L;